export var numberWithCommas = function (num) {
    return Number(num)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var roundUpNumberWithCommas = function (num, decimalPostion) {
    if (num === 0) {
        return '0';
    }
    if (!num || num === null || undefined) {
        return '';
    }
    return Math.ceil(Number(num))
        .toFixed(decimalPostion)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var floorNumberWithCommas = function (num, decimalPostion) {
    if (num === 0) {
        return '0';
    }
    if (!num || num === null || undefined) {
        return '';
    }
    return Math.floor(Number(num))
        .toFixed(decimalPostion)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var stringWithCommas = function (num) {
    return String(num)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var defaultFormat = function (num) {
    if (!num || num === null || undefined) {
        return '$0.00';
    }
    var val = numberWithCommas(num);
    return num < 0 ? "-$".concat(val.slice(1)) : "$".concat(val);
};
export var stringWithDecimal = function (num) {
    var array = num.split('.', 2);
    var discount;
    if (array.length === 2) {
        if (array[1] === '0' || array[1] === '00') {
            discount = array[0];
        }
        else if (array[1].length === 1) {
            discount = "".concat(array[0], ".").concat(array[1], "0");
        }
        else {
            discount = "".concat(array[0], ".").concat(array[1]);
        }
    }
    else {
        discount = num;
    }
    return discount;
};
export var priceSplit = function (num) {
    var priceSplitValue = num.toFixed(2).split('.');
    return {
        dollars: Number(priceSplitValue[0]).toLocaleString(),
        cents: priceSplitValue[1],
    };
};
export var priceStringToNumber = function (priceString) {
    return Number(priceString.replace(/[^0-9.-]+/g, ''));
};
